import { JwtAxios } from '@/packaging';

export const accountAPI = {
  async UserCreate(model) {
    const responseModel = await JwtAxios.post(`/Account/UserCreate`, model);
    return responseModel;
  },
  async getTerms() {
    const responseModel = await JwtAxios.get(`/Account/GetTerms`);
    return responseModel;
  },
  async sendCertificationMail(model) {
    const responseModel = await JwtAxios.post('/Account/SendCertificationMail', model);
    return responseModel;
  },
  async checkCertificationMail(model) {
    const responseModel = await JwtAxios.post('/Account/CheckCertificationMail', model);
    return responseModel;
  },
  async findPassword(model) {
    const responseModel = await JwtAxios.post('/Account/FindPassword', model);
    return responseModel;
  },
  async GetUserRestrics() {
    const res = await JwtAxios.get('/Account/GetUserRestrics');
    return res;
  },
  async unsubscribe(model) {
    const res = await JwtAxios.post('/Account/Unsubscribe', model);
    return res;
  },
  async GetUserPrivateSites() {
    const res = await JwtAxios.get('/Account/GetUserPrivateSites');
    return res;
  },
  // 직원계정 관리 API
  async getSubUsers() {
    const res = await JwtAxios.get('/Account/GetSubUsers');
    return res;
  },
  async addSubUser(model) {
    const res = await JwtAxios.post('/Account/AddSubUser', model);
    return res;
  },
  async updateSubUser(model) {
    const res = await JwtAxios.post('/Account/UpdateSubUser', model);
    return res;
  },
  async deleteSubUsers(idxList) {
    const res = await JwtAxios.post('/Account/DeleteSubUsers', { idxList });
    return res;
  },
  async getSubUserPermissions() {
    const res = await JwtAxios.get('/Account/GetSubUserPermissions');
    return res;
  }
};
